document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.remove('page-loading');

    var backToTop = document.getElementById('back-to-top');
    var isDesktopNavbar = window.matchMedia('(min-width: 770px)');

    function updateBackToTop() {
        if (!backToTop) {
            return;
        }

        backToTop.style.display = window.scrollY > 50 ? 'block' : 'none';
    }

    if (backToTop) {
        window.addEventListener('scroll', updateBackToTop, { passive: true });
        updateBackToTop();

        backToTop.addEventListener('click', function (event) {
            event.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }

    document.querySelectorAll('.navbar .dropdown').forEach(function (dropdown) {
        var showTimer;
        var hideTimer;

        function getMenu() {
            return dropdown.querySelector('.dropdown-menu');
        }

        dropdown.addEventListener('mouseenter', function () {
            if (!isDesktopNavbar.matches) {
                return;
            }

            clearTimeout(hideTimer);
            showTimer = window.setTimeout(function () {
                var menu = getMenu();
                if (!menu) {
                    return;
                }

                menu.classList.add('show');
                menu.style.display = 'block';
            }, 250);
        });

        dropdown.addEventListener('mouseleave', function () {
            if (!isDesktopNavbar.matches) {
                return;
            }

            clearTimeout(showTimer);
            hideTimer = window.setTimeout(function () {
                var menu = getMenu();
                if (!menu) {
                    return;
                }

                menu.classList.remove('show');
                menu.style.display = '';
            }, 100);
        });
    });

    document.querySelectorAll('.navbar .dropdown > a').forEach(function (link) {
        link.addEventListener('click', function () {
            if (isDesktopNavbar.matches) {
                window.location.href = link.href;
            }
        });
    });
});
